<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editData" ref="editDataRef" label-width="75px">
          <el-form-item label="区域分布" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-select v-model="editData.regional" placeholder="请选择区域分布" class="select">
             <el-option
               v-for="item in regionalList" :key="item.value" :label="item.label" :value="item.value">
             </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="editData.province" placeholder="请输入省"></el-input>
          </el-form-item>
          <el-form-item label="市" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="editData.city" placeholder="请输入市"></el-input>
          </el-form-item>
          <el-form-item label="区" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="editData.district" placeholder="请输入区"></el-input>
          </el-form-item>
          <el-form-item label="门店名称" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <Rsljigou :propsjigouid="editData.jigouid" :propsjigouname="editData.name" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="类别" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-select v-model="editData.category" placeholder="请选择类别" class="select">
              <el-option
                v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负责人" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="editData.head" placeholder="请输入负责人"></el-input>
          </el-form-item>
          <el-form-item label="电话" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="editData.phone" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item label="地址" class="addAdminForm">
            <el-input v-model="editData.address" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="所属运营" class="addAdminForm" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="editData.operating" placeholder="请输入所属运营"></el-input>
          </el-form-item>
          <el-form-item label="状态" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-select v-model="editData.status" placeholder="请选择状态" class="select">
              <el-option
                v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="editData.note" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      regionalList: [],
      categoryList: [],
      statusList: [],
      editData: {
        id: '',
        regional: '',
        province: '',
        city: '',
        district: '',
        jigouid: '',
        name: '',
        category: '',
        head: '',
        phone: '',
        address: '',
        operating: '',
        status: '',
        note: ''
      },
      SubRule_GlassJigouInformation_CompleteInfo: false
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row, regionalList, categoryList, statusList, SubRuleGlassJigouInformationCompleteInfo) {
      this.editData.id = row.Id
      this.editData.regional = row.Regional
      this.editData.province = row.Province
      this.editData.city = row.City
      this.editData.district = row.District
      this.editData.name = row.Name
      this.editData.category = row.Category
      this.editData.head = row.Head
      this.editData.phone = row.Phone
      this.editData.address = row.Address
      this.editData.operating = row.Operating
      this.editData.status = row.Status
      this.editData.note = row.Note

      this.regionalList = regionalList
      this.categoryList = categoryList
      this.statusList = statusList
      this.SubRule_GlassJigouInformation_CompleteInfo = SubRuleGlassJigouInformationCompleteInfo
    },
    changeRsljigou (vid, vname) {
      this.editData.jigouid = vid
      this.editData.name = vname
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditGlassJigouInformation()
    },
    apiEditGlassJigouInformation: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        editid: that.editData.id,
        regional: that.editData.regional,
        province: that.editData.province,
        city: that.editData.city,
        district: that.editData.district,
        name: that.editData.name,
        category: that.editData.category,
        head: that.editData.head,
        phone: that.editData.phone,
        address: that.editData.address,
        operating: that.editData.operating,
        status: that.editData.status,
        note: that.editData.note
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditGlassJigouInformation, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
